import React from 'react';

import { cn } from '../../lib/utils';

// Over a workspace background image the pill is light glass (white/10 + hairline,
// no drop shadow — it artifacted over imagery), scoped via the
// .has-workspace-background-image ancestor, which outranks the theme classes;
// plain light/dark themes keep the normal soft drop shadow.
const JumpToNewest = ({ isVisible, onJump }) => {
  return (
    <button
      type="button"
      onClick={onJump}
      data-app-region="none"
      data-feed-jump-to-present
      tabIndex={isVisible ? 0 : -1}
      aria-hidden={!isVisible}
      className={cn(
        'z-(--stack-messages-jump-to-newest) flex h-9 w-37 cursor-pointer items-center justify-center gap-2 rounded-full text-[13px] leading-[22px] font-medium text-white transition-all duration-200 [&>*]:select-none',
        'bg-gray-950/80 backdrop-blur drop-shadow-lg hover:bg-gray-950 dark:bg-gray-800/60 dark:hover:bg-gray-800/90',
        '[.has-workspace-background-image_&]:bg-white/10 [.has-workspace-background-image_&]:shadow-[inset_0_0_0_1px_rgba(255,255,255,0.2)] [.has-workspace-background-image_&]:drop-shadow-none [.has-workspace-background-image_&]:backdrop-blur-[15px] [.has-workspace-background-image_&]:backdrop-saturate-200 [.has-workspace-background-image_&]:hover:bg-white/20',
        isVisible ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
      )}
    >
      <span aria-hidden="true">↓</span>
      <span>Jump to Present</span>
    </button>
  );
};

export default JumpToNewest;
